<template>
  <el-main>
    <el-row>    
      成绩报表:项目=>{{ sel_xm }}{{ ' ' }}科目=>总分报表   
    </el-row>



   <vxe-button @click="exameSchoolbaobiao">获取报表数据</vxe-button> 
   <vxe-button @click="generatePDF">导出pdf</vxe-button> 

  </el-main>
</template>
<script>
	import axios from 'axios'
	import qs from 'qs'
	import localStorage from 'localStorage'
  import ExcelJS from 'exceljs'
  import XEUtils from 'xe-utils'
  import jsPDF from 'jspdf'
  import 'jspdf-autotable'


	export default {
		data() {
		  return {
			kemulist: [],
      baobiaodata:[],
      activeName: '0',
			defaultProps: {
			   children: 'children',
						label: 'label',
						level: 'level'
					},
				sel_xm:'',
        sel_kemu:'',
        sel_School:'',
        sel_tizu:'',
        is_disable:true,
				is_jindu_disable:true,
				options:[],
				cascagerdefault: ["0", "0", ""],
				zongfenshow:false,
        dankeshow:false,
        sel_xm:'',
        items: [],
        tmpitems:[],
        fields: [],
        tizus: [],
        dankescore: [],
        tmpdankescore: [],
        headVariant:'light',
        totalRows: 0,
        danketotalRows:0,
        currentPage: 1,
        perPage: 30,
        filter: null,
        filterOn: ['kh','nm','cl'],
        user_school:'',
        loading:false,
        filterName1:'', 
        filterName2:'',
        zfdata:[],
            

		  };
		},
	
		mounted:function(){
			 
	
			  
		},

    activated() {

      this.getopt();//需要触发的函数

      },
          
	
		methods: {
       headRows() {
          return [
            { class: '班级', avgscore: '平均分', rank: '排名' },
          ]
        },

       bodyRows(rowCount) {
          rowCount = rowCount || 10
          var body = []
          for (var j = 1; j <= rowCount; j++) {
            body.push({
              id: j,
              name: '姓名:'+j,
              email: 'email'+j,
              city: 'address'+j,
              expenses: 'expenses'+j,
            })
          }
          return body
        },

      generateReport () {
          //  this.$refs.html2Pdf.generatePdf()

            const doc = new jsPDF()
            let finalY = doc.lastAutoTable.finalY || 10
            doc.text('From javascript arrays', 14, finalY + 15)
            doc.autoTable({
                          startY: finalY + 20,
                          head: [['ID', 'Name', 'Email', 'Country', 'IP-address']],
                          body: [
                            ['1', 'Donna', 'dmoore0@furl.net', 'China', '211.56.242.221'],
                            ['2', 'Janice', 'jhenry1@theatlantic.com', 'Ukraine', '38.36.7.199'],
                            [
                              '3',
                              'Ruth',
                              'rwells2@constantcontact.com',
                              'Trinidad and Tobago',
                              '19.162.133.184',
                            ],
                            ['4', 'Jason', 'jray3@psu.edu', 'Brazil', '10.68.11.42'],
                            ['5', 'Jane', 'jstephens4@go.com', 'United States', '47.32.129.71'],
                            ['6', 'Adam', 'anichols5@com.com', 'Canada', '18.186.38.37'],
                          ],
                        })

            doc.save('table.pdf')
        },

        generatePDF () {
                var doc = new jsPDF()
                
           
                doc.addFont("simhei.ttf", "PTSans", "normal")              


                doc.setFont("PTSans")




                var totalPagesExp = 32
                //报告首页 
                let finalY = doc.lastAutoTable.finalY || 10
                doc.setFontSize(60)
                doc.text('学校分析报告', 14, finalY + 15)
                let xm=this.sel_xm
                let grade=xm.substring(xm.indexOf('(')+1,xm.indexOf(')'))               

                doc.setFontSize(20)
                doc.text(grade, 14, finalY + 45)

                //年级框
                doc.rect(10, finalY + 35, grade.length*10, 12)

                doc.setLineWidth(0.1)
                doc.line(14, finalY + 65, 150, finalY + 65)

                doc.setFontSize(29)
                doc.text(this.sel_xm, 14, finalY + 75)

                doc.setFontSize(20)
                doc.text(this.user_school, 14, finalY + 105)

                let currentDate = new Date();
                let dateOnly = currentDate.toISOString().slice(0,10);

                doc.text(dateOnly, 14+this.user_school.length*20, finalY + 105)


                //索引页  在所有数据页生成完毕以后  调用   doc.setPage(1)
              //  doc.addPage()

                doc.setFontSize(12)
                let rectX = 25, rectY = 10, rectW = 25, rectH = 25;              
                //doc.textWithLink('第二页',rectX, rectY, {pageNumber: 4})
                    rectX = 25, rectY = 50, rectW = 25, rectH = 25;              
                //doc.textWithLink('第三页',rectX, rectY, {pageNumber: 5})

                doc.addPage()

                doc.autoTable({
                  head:  [{ class: '班级', avgscore: '平均分', rank: '排名',maxscore:'最高分' },],
                  body: this.zfdata,
                  theme: 'grid',
                  styles: { font: 'PTSans', fontStyle: 'normal', textColor: [0, 0, 0], halign: 'center' },
                  willDrawPage: function (data) {
                    // Header
                    doc.setFontSize(12)
                    doc.setTextColor(40)
                  //  if (base64Img) {
                      doc.addImage('book.jpg', 'png', data.settings.margin.left, 15, 10, 10)
                   // }
                    doc.rect(data.settings.margin.left + 12, 16, 25, 10);
                    doc.text('天一大联考', data.settings.margin.left + 15, 22)
                    // Filled square
                    doc.rect(data.settings.margin.left + 37, 16, 28, 10, "F");
                    doc.setTextColor(255)
                    doc.setFontSize(12)
                    doc.text('学校分析报告', data.settings.margin.left + 39, 22)
                    
                    doc.setTextColor(40)
                  },
                 
                  margin: { top: 20 },
                })

                //单科报表
                  // Document defaults
                  jsPDF.autoTableSetDefaults(
                      {
                        headStyles: { fillColor: [155, 89, 182] }, // Purple
                        didDrawPage: function (data) {
                          var finalY = doc.lastAutoTable.finalY + 15
                          var leftMargin = data.settings.margin.left
                         
                        },
                      },
                      doc
                    )


                for (let i = 0; i < this.kemulist.length; i++) { 

                  let tmpkemu=this.kemulist[i]['km']
                  console.log(tmpkemu)
                  
                  doc.text(tmpkemu, 14, doc.lastAutoTable.finalY+ 15)
                  let startY = doc.lastAutoTable.finalY + 20


                  doc.autoTable({
                  head:  [{ class: '班级', avgscore: '平均分', rank: '排名',maxscore:'最高分' },],
                  body: this.baobiaodata['s'+i],
                  startY: startY,
                  theme: 'grid',
                  styles: { font: 'PTSans', fontStyle: 'normal', textColor: [0, 0, 0], halign: 'center' },
                  willDrawPage: function (data) {
                    // Header
                    doc.setFontSize(12)
                    doc.setTextColor(40)
                  //  if (base64Img) {
                    //  doc.addImage('book.jpg', 'png', data.settings.margin.left, 5, 10, 10)
                   // }
                   // doc.rect(data.settings.margin.left + 12, 11, 25, 10);
                  //  doc.text('天一大联考', data.settings.margin.left + 15, 12)
                    // Filled square
                  //  doc.rect(data.settings.margin.left + 37, 11, 28, 10, "F");
                    doc.setTextColor(255)
                    doc.setFontSize(12)
                   // doc.text('学校分析报告', data.settings.margin.left + 39, 12)
                    
                    doc.setTextColor(40)
                  },
                  didDrawPage: function (data) {
                    // Footer
                    var str = '_'+ doc.internal.getNumberOfPages()+'_'                    
                    doc.setFontSize(10)

                    //页码居中
                    let textWidth = doc.getStringUnitWidth(str) * doc.internal.getFontSize() / doc.internal.scaleFactor
                    let textOffset = (doc.internal.pageSize.width - textWidth) / 2
                     

                    // jsPDF 1.4+ uses getHeight, <1.4 uses .height
                    var pageSize = doc.internal.pageSize
                    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                   // doc.text(str, data.settings.margin.left, pageHeight - 10)
                    doc.text(str,textOffset, pageHeight - 10)
                  },
                  margin: { top: 20 },
                })
                }
                doc.autoTableSetDefaults(null)
                jsPDF.autoTableSetDefaults(null)
                
            doc.save('table.pdf')
        },
      exportdankedata() {
              const workbook = new ExcelJS.Workbook()
              const worksheet = workbook.addWorksheet(this.user_school)
              let xlshead=[]
              for (let i=0;i<this.tizus.length;i++)
              {
                let onedankeitem=this.tizus[i]['tihao']
                xlshead.push(onedankeitem)                
              }

              // 添加表头
              worksheet.addRow(xlshead)

              // 添加数据
              this.dankescore.forEach(onescore => {

              let onestscore=[]        

              for (let i=0;i<this.tizus.length;i++)
              {                 
               // onestscore.push(onescore[i])                
              }

                worksheet.addRow(onescore)
              })
              

              // 导出Excel文件
              workbook.xlsx.writeBuffer().then(buffer => {
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                //自动列宽 begin
                for (let i = 0; i < worksheet.columns.length; i += 1) { 
                    let dataMax = 0;
                    const column = worksheet.columns[i];
                    for (let j = 1; j < column.values.length; j += 1) {
                      const columnLength = column.values[j].length;
                      if (columnLength > dataMax) {
                        dataMax = columnLength;
                      }
                    }
                    column.width = dataMax < 10 ? 10 : dataMax;
                  }
                 //自动列宽 end

                const filename = "导出" + ".xlsx";
               // saveAs(blob, filename);
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.download = this.sel_kemu+'.xlsx'
                link.click()
                window.URL.revokeObjectURL(url)
              })
            },

      exportzfdata() {
              const workbook = new ExcelJS.Workbook()
              const worksheet = workbook.addWorksheet(this.user_school)
              let xlshead=[]
              for (let i=0;i<this.fields.length;i++)
              {
                let onekemu=this.fields[i]['title']
                xlshead.push(onekemu)                
              }

              // 添加表头
              worksheet.addRow(xlshead)

              // 添加数据
              this.items.forEach(onescore => {

              let onestscore=[]
              onestscore.push(onescore.kh)
              onestscore.push(onescore.nm)
              onestscore.push(onescore.sc)
              onestscore.push(onescore.cl)
              onestscore.push(onescore.zf)

              for (let i=0;i<this.fields.length-5;i++)
              {                 
                onestscore.push(onescore[i])                
              }

                worksheet.addRow(onestscore)
              })
              

              // 导出Excel文件
              workbook.xlsx.writeBuffer().then(buffer => {
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                //自动列宽 begin
                for (let i = 0; i < worksheet.columns.length; i += 1) { 
                    let dataMax = 0;
                    const column = worksheet.columns[i];
                    for (let j = 1; j < column.values.length; j += 1) {
                      const columnLength = column.values[j].length;
                      if (columnLength > dataMax) {
                        dataMax = columnLength;
                      }
                    }
                    column.width = dataMax < 10 ? 10 : dataMax;
                  }
                 //自动列宽 end

                const filename = "导出" + ".xlsx";
               // saveAs(blob, filename);
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.download = '总成绩.xlsx'
                link.click()
                window.URL.revokeObjectURL(url)
              })
            },
		
      handleClick(tab, event) {
        console.log(tab, event)
        console.log(this.activeName)
        let selkemu=this.kemulist[this.activeName]
        this.sel_kemu=selkemu
        this.fields=[]
        this.items=[]
        this.tizus=[]
        this.dankescore=[]
        this.loading=true
        if (selkemu=='总分')
        {
          console.log('总分'+'成绩....')
          this.getSchooScore()	
          this.zongfenshow=true
          this.dankeshow=false		 
         

        }
        else
        {
          this.zongfenshow=false
          this.dankeshow=true	
          this.getSchooDanke()
         
        }
        //获取对应科目上传信息
      },
		 
			getopt(){		
				        	console.log('请求开始');
			 
                  this.sel_xm=localStorage.getItem('xm')
                  let kemul=localStorage.getItem('kemu')
            
                  this.user_school=localStorage.getItem('user_school')
                  
 
			},
      exameSchoolbaobiao () {
      
         this.sel_School=''
         axios.post('/cjman?op=exameSchoolbaobiao',qs.stringify({"xm":this.sel_xm,'school':this.sel_School})).then((res)=>{
          
              console.log(res.data)
               
              console.log(res.data.class)
              this.zfdata=res.data.allscore
              this.kemulist=res.data.kemu
              this.baobiaodata=res.data
              this.loading=false
              console.log(res.data.allscore)
              const instance = this.$notify({
                type: 'success',
                title: '获取成功',
                message: '总成绩报表数据!',
              })

              
          }).catch((res)=>{
              console.log(response)
          })
    },

    getSchooDanke() {
      
      let xm=this.sel_xm
      let grade=xm.substring(xm.indexOf('(')+1,xm.indexOf(')'))
      console.log('年级:'+grade);	

      this.sel_School=''
      axios.post('/cjman?op=exameSchoolDanke',qs.stringify({"xm":this.sel_xm,'kemu':this.sel_kemu,'grade':grade})).then((res)=>{
           console.log(res)
           this.filter=null
           this.tizus=res.data.tizu
           this.dankescore=res.data.dankescore
           this.tmpdankescore=this.dankescore
           this.danketotalRows= this.dankescore.length;
           console.log(res.data.tizu)
           console.log(res.data.dankescore)
           this.loading=false
           
       }).catch((res)=>{
           console.log(response)
       })
 },
 searchEvent1 () {
              const filterName = XEUtils.toValueString(this.filterName1).trim().toLowerCase()
              if (filterName) {
                const filterRE = new RegExp(filterName, 'gi')
                const searchProps = ['0', '1']
                const rest = this.tmpdankescore.filter(item => searchProps.some(key => XEUtils.toValueString(item[key]).toLowerCase().indexOf(filterName) > -1))
                this.dankescore = rest.map(row => {
                  const item = Object.assign({}, row)
                  searchProps.forEach(key => {
                    item[key] = XEUtils.toValueString(item[key]).replace(filterRE, match => `${match}`)
                  })
                  return item
                })
                this.danketotalRows=this.dankescore.length
              } else {
                this.dankescore = this.tmpdankescore
                this.danketotalRows=this.dankescore.length
              }
        },
    searchEvent2 () {
              const filterName = XEUtils.toValueString(this.filterName2).trim().toLowerCase()
              if (filterName) {
                const filterRE = new RegExp(filterName, 'gi')
                const searchProps = ['kh', 'nm']
                const rest = this.tmpitems.filter(item => searchProps.some(key => XEUtils.toValueString(item[key]).toLowerCase().indexOf(filterName) > -1))
                this.items = rest.map(row => {
                  const item = Object.assign({}, row)
                  searchProps.forEach(key => {
                    item[key] = XEUtils.toValueString(item[key]).replace(filterRE, match => `${match}`)
                  })
                  return item
                })
                this.totalRows=this.items.length
              } else {
                this.items = this.tmpitems
                this.totalRows=this.items.length
              }
        },


     
	
 
	
		}
	  };
	</script>
	